import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {UserLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultPrimaryManagerDataSelector,
    accountSearchResultPrimaryManagerResultSelector,
} from '../../slices/account-search-result-primary-manager.slice';

type Props = {
    accountId: number,
};

export const PrimaryManagerCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultPrimaryManagerDataSelector);
    const result = useSelector(accountSearchResultPrimaryManagerResultSelector);

    const manager = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !manager) {
        return null;
    }

    return (
        <UserLink
            userId={manager.userId}
            place={PLACE}
            caption={[manager.firstName, manager.lastName].filter(Boolean).join(' ') || manager.email}
        />
    );
};
